'use strict';
var localisations = require('../account.localisations');

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $location, common, notifications) {
    var that = this;
    this.Auth = Auth;
    this.$location = $location;
    this.common = common;
    this.common.setPageTitle('');
    this.common.setBack(null, null);
    this.common.showNavbar(true);
    this.notifications = notifications;
    this.localisations = localisations[this.common.getLocale()];
    this.notifications.resetNotifications();
    this.notifications.initialise(function(numberOfNotifications) {
      common.setLoading(false);
    }, function(){
      common.setLoading(false);
    })
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email,
        password: this.user.password
      })
        .then(() => {
          // Logged in, redirect to home
          this.$location.path('/dashboard');
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js